import { nextTick } from 'vue'
import { app } from '@/main'

export default {
    mounted(el, binding) {
        nextTick(() => {
            const permissionsList =
                app?.config?.globalProperties.permissionsList

            // if (!permissionsList || !permissionsList.includes(binding.value)) {
            if (!permissionsList || !binding.value.some(v => permissionsList.includes(v))) {
                if (el) {
                    if (el.parentNode) {
                        el.parentNode.removeChild(el)
                    }
                }
            }
        })
    }
}
